import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_QUEUE,
  UPDATE_QUEUE,
  CREATE_QUEUE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { VoAuth } from "@vocollege/app";
import Utils from "services/Utils";

export default function QueueEdit() {
  const router = useParams<any>();
  const navigate = useNavigate();

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      title: "",
      status: 0,
      url: "",
      body: "",
      author: null,
      tags: [],
      items: [],
      columns: "0",
      images: [],
      attachments: [],
    };
    const { id } = router;
    if (id && id === "create") {
      initialState.author = {
        id: VoAuth.currentUser.id,
        name: VoAuth.currentUser.name,
        type: "user",
      };
    }
    return initialState;
  };

  const getAvailableColumns = () => {
    return Object.keys(I18n.get.queue.columns).map((v: string) => ({
      label: I18n.get.queue.columns[v],
      value: v,
    }));
  };

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/queues");
    }
  };

  return (
    <Layout>
      <Form
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "url",
                label: I18n.get.form.labels.url,
                type: "url_field",
                grid: {
                  xs: 12,
                },
                params: {
                  fieldLock: false,
                },
              },
              {
                name: "author",
                label: I18n.get.misc.author,
                type: "entity_field",
                grid: {
                  xs: 12,
                  md: 6,
                },
                params: {
                  dialog: {
                    types: ["user"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                  },
                },
              },
              {
                name: "columns",
                label: I18n.get.form.labels.highestNumberOfColumns,
                type: "select",
                grid: {
                  xs: 12,
                  md: 6,
                },
                params: {
                  availableValues: getAvailableColumns,
                },
              },
              {
                name: "tags",
                label: I18n.get.tag.labels.tags,
                type: "tags_field",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["tag"],
                    addNew: true,
                  },
                },
              },
              {
                name: "images",
                label: I18n.get.misc.image,
                type: "file_field",
                grid: {
                  xs: 12,
                },
                params: {
                  filetypes: ["image"],
                  multiple: false,
                },
              },
              {
                name: "body",
                label: I18n.get.form.labels.body,
                type: "editor",
                required: false,
                grid: {
                  xs: 12,
                },
              },
            ],
          },
          {
            key: "items",
            label: I18n.get.form.labels.itemsToQueue,
            fields: [
              {
                name: "items",
                label: I18n.get.form.labels.itemsToQueue,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: [
                      "article",
                      "page",
                      "section",
                      "user",
                      "event",
                      "card",
                    ],
                  },
                  renderItemTitle: (item: any) => item.title || item.label,
                  // fields: {
                  //   article: {
                  //     title: "title",
                  //   },
                  //   page: {
                  //     title: "title",
                  //   },
                  //   section: {
                  //     title: "title",
                  //   },
                  //   user: {
                  //     title: "name",
                  //   },
                  //   event: {
                  //     title: "title",
                  //   },
                  //   card: {
                  //     title: "title",
                  //   },
                  // },
                },
              },
            ],
          },
          {
            key: "attachments",
            label: I18n.get.misc.attachments,
            fields: [
              {
                name: "attachments",
                label: I18n.get.misc.attachments,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  contentType: "file",
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.form.labels.createQueue,
          created: I18n.get.queue.messages.queueSaved,
          updated: I18n.get.queue.messages.queueSaved,
          deleted: I18n.get.queue.messages.queueDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "queue",
          get: GET_QUEUE,
          create: CREATE_QUEUE,
          update: UPDATE_QUEUE,
          // search: SEARCH_QUEUEABLE_ITEMS,
        }}
        // paths={{
        //   back: "/content/queues",
        // }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
